<template v-if="this.rows.length">
    <template v-for="row in this.rows">
        <div class="card board-card" v-bind:data-clickable="row.clickable_el ? 'true' : 'false'" v-bind:data-clickable-url="row.clickable_el.url">
            <div class="card--header">
                <h4 class="card--title">
                    {{ row.details_heading_title }}
                </h4>
            </div>

            <div v-if="this.options.board.cards_layout.details_rows" class="card--body">
                <template v-for="item in row.rows_data">
                    <div class="card--description Stack Stack--small">
                        <div v-if="item.name" class="caption-uppercase color-gray">
                            {{item.name}}
                        </div>
                        {{item.value}}
                    </div>
                </template>
            </div>

            <template v-if="row.status_actions">
                <div class="card--footer card--action-buttons">
                    <template v-for="action_btn in row.status_actions">
                        <!-- Check the button_type -->
                        <template v-if="action_btn.button_type === 'text-button'">
                            <a :href="action_btn.url" class="Btn Btn--small">{{ action_btn.button_text }}</a>
                        </template>
                        <template v-else-if="action_btn.button_type === 'icon-button'">
                            <a :href="action_btn.url" class="Btn Btn--small"><span :class="action_btn.button_icon"></span></a>
                        </template>
                    </template>
                </div>
            </template>
        </div>
    </template>
</template>

<script>
export default {
    name: 'CardComponent',
    props: {
        postSlug: String,
        postId: String,
        rows: {
            type: Object,
            required: true,
            default: {}
        },
        options: {
            type: Object,
            required: true,
            default: {}
        }
    }
}
</script>